export function prettyJSON(json) {
  return JSON.stringify(json, null, 2)
}

export function parseJSON(json) {
  try {
    return JSON.parse(json)
  } catch {
    return null
  }
}

export function stringifyJSON(json) {
  return JSON.stringify(json)
}

export function deepClone(obj) {
  return parseJSON(stringifyJSON(obj))
}
